import "./kendo.core.js";
import "./kendo.drawing.js";
import "./pdf/core.js";
import "./pdf/mixins.js";

export const __meta__ = {
    id: "pdf",
    name: "PDF export",
    description: "PDF Generation framework",
    mixin: true,
    category: "framework",
    depends: [ "core", "drawing" ]
};
